import editorCapabilitiesConstants from '../../editorCapabilities/editorCapabilitiesTypes';

/**
 * @description These are the the children of the insert menu, shown in a particular order.
 */
export const INSERT_CAPABILITIES = [
  editorCapabilitiesConstants.KNOWLEDGE_ARTICLE,
  editorCapabilitiesConstants.SNIPPETS,
  editorCapabilitiesConstants.VIDEO_INSERTION,
  editorCapabilitiesConstants.MEETINGS,
  editorCapabilitiesConstants.DOCUMENTS,
  editorCapabilitiesConstants.QUOTES,
  editorCapabilitiesConstants.PAYMENT_LINK,
  editorCapabilitiesConstants.TEMPLATES,
  editorCapabilitiesConstants.INVOICES,
  editorCapabilitiesConstants.SIGNATURE,
];
